import * as React from "react";
import BaseModal, { BaseModalContent } from "../BaseModal";
import AddAddressModalForm from "../../Forms/profile/AddAddressModalForm";
import { useDispatch } from "react-redux";
import { getStates } from "../../../store/profile/action";
import { useParams } from "react-router";
import HomeIcon from "@material-ui/icons/Home";

const AddAddressModal=(props)=>{ 
    const {isOpenAddAddressModal,handleCloseAddAddressModal} = props;
    const UserParams = useParams();
    const dispatch = useDispatch();
    React.useEffect(()=>{
        dispatch(getStates(UserParams.customer));    
    },[])
   
    return(
        <BaseModal
            title="Add Account Address"
            align="center"
            icon={<HomeIcon />}
            open={isOpenAddAddressModal}
            onClose={handleCloseAddAddressModal}
            fullWidth
            className="modal-header"
            disableBackdropClick
        >
            <BaseModalContent>
                <AddAddressModalForm handleClose={handleCloseAddAddressModal}/>
            </BaseModalContent>
        </BaseModal>
    );
};

export default AddAddressModal;